import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M19 6.024L17.976 5 12 10.983 6.024 5 5 6.024 10.983 12 5 17.976 6.024 19 12 13.017 17.976 19 19 17.976 13.017 12 19 6.024z" }));
export default createSvgIcon(iconPath, "Close");
//# sourceMappingURL=CloseIcon.js.map